import { render, staticRenderFns } from "./DeleteClientModal.vue?vue&type=template&id=0c9d9877"
import script from "./DeleteClientModal.vue?vue&type=script&lang=js"
export * from "./DeleteClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports